// src/components/pos/POSNavigation.jsx
// POS Navigation Components - Direct display of all 6 navigation buttons

import SaleSummary from './SaleSummary'
import SalesHistory from './SalesHistory'
import Stocks from './Stocks'
import StockAlerts from './Alerts'
import Returns from './Returns'
import Reports from './Reports'
import { cn } from '../../utils/cn'

// Main Navigation Container Component - Shows all 6 buttons directly
const POSNavigation = ({ className, branchId, branchInfo, ...props }) => {
  return (
    <div 
      className={cn(
        "fixed top-20 left-4 z-[99999]",
        className
      )}
      style={{ zIndex: 99999 }} // Force high z-index
      {...props}
    >
      {/* Navigation Grid - 1 row with 5 columns (Alerts hidden) */}
      <div className="grid grid-cols-5 gap-2 p-3 bg-white shadow-xl border-2 border-orange-500 rounded-lg">
        <SaleSummary branchId={branchId} />
        <SalesHistory branchId={branchId} />
        <Stocks />
        {/* <StockAlerts /> */}
        <Returns branchId={branchId} />
        <Reports selectedBranch={branchInfo} />
      </div>
    </div>
  )
}

export default POSNavigation
